import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MenuComponent } from './menu/menu.component';
import { MaterialModule } from '../material/material.module';
import { RouterModule } from '@angular/router';
import { ConfirmDialogComponent } from './dialogs/confirm-dialog.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import { TooltipDirective } from './tooltip/tooltip.directive';
import { InsightCardsComponent } from './insight-cards/insight-cards.component';
import { SearchComponent } from './search/search.component';
import { RequestDialogComponent } from './dialogs/request-dialog.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { GroupSelectionComponent } from './group-selection/group-selection.component';
import { CommentDialogComponent } from './dialogs/comment-dialog.component';
import { NodeImageComponent } from './svgs/node-image.component';
import { PopupCarouselComponent } from './carousel/popup-carousel.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        MenuComponent,
        ConfirmDialogComponent,
        TooltipComponent,
        TooltipDirective,
        InsightCardsComponent,
        SearchComponent,
        RequestDialogComponent,
        NotificationsComponent,
        GroupSelectionComponent,
        CommentDialogComponent,
        NodeImageComponent,
        PopupCarouselComponent,
    ],
    exports: [
        MenuComponent,
        TooltipDirective,
        InsightCardsComponent,
        RequestDialogComponent,
        GroupSelectionComponent,
        CommentDialogComponent,
        NodeImageComponent,
        PopupCarouselComponent,
    ],
    imports: [MaterialModule, FormsModule, RouterModule, CommonModule],
    providers: [],
})
export class UIComponentsModule {}
